// extracted by mini-css-extract-plugin
module.exports = {"kontaktskjema":"Kontaktskjema_kontaktskjema__yR6je"};